import ReactCountryFlag from 'react-country-flag';
import { useState, useRef, useEffect } from 'react';
import './Settings.css';
import Layout from '../../../components/Layout';
import AdminNavbar from '../../../components/Admin/AdminNavbar/AdminNavbar';
// import ISO6391 from "iso-639-1"
import { Box, Typography, Avatar } from '@mui/material';
import { axiosInstance } from '../../../utils/tokenUtils';
import toast from 'react-hot-toast';
import { ProfileSkeleton } from '../../../components/Admin/SkeletonLoader/SkeletonLoader';
import { useProfile } from '../../../context/ProfileContext';

const countryCodeMap = {
  AF: { code: '+93', name: 'Afghanistan' },
  AL: { code: '+355', name: 'Albania' },
  DZ: { code: '+213', name: 'Algeria' },
  AS: { code: '+1684', name: 'American Samoa' },
  AD: { code: '+376', name: 'Andorra' },
  AO: { code: '+244', name: 'Angola' },
  AI: { code: '+1264', name: 'Anguilla' },
  AG: { code: '+1268', name: 'Antigua and Barbuda' },
  AR: { code: '+54', name: 'Argentina' },
  AM: { code: '+374', name: 'Armenia' },
  AW: { code: '+297', name: 'Aruba' },
  AU: { code: '+61', name: 'Australia' },
  AT: { code: '+43', name: 'Austria' },
  AZ: { code: '+994', name: 'Azerbaijan' },
  BS: { code: '+1242', name: 'Bahamas' },
  BH: { code: '+973', name: 'Bahrain' },
  BD: { code: '+880', name: 'Bangladesh' },
  BB: { code: '+1246', name: 'Barbados' },
  BY: { code: '+375', name: 'Belarus' },
  BE: { code: '+32', name: 'Belgium' },
  BZ: { code: '+501', name: 'Belize' },
  BJ: { code: '+229', name: 'Benin' },
  BM: { code: '+1441', name: 'Bermuda' },
  BT: { code: '+975', name: 'Bhutan' },
  BO: { code: '+591', name: 'Bolivia' },
  BA: { code: '+387', name: 'Bosnia and Herzegovina' },
  BW: { code: '+267', name: 'Botswana' },
  BR: { code: '+55', name: 'Brazil' },
  BN: { code: '+673', name: 'Brunei' },
  BG: { code: '+359', name: 'Bulgaria' },
  BF: { code: '+226', name: 'Burkina Faso' },
  BI: { code: '+257', name: 'Burundi' },
  KH: { code: '+855', name: 'Cambodia' },
  CM: { code: '+237', name: 'Cameroon' },
  CA: { code: '+1', name: 'Canada' },
  CV: { code: '+238', name: 'Cape Verde' },
  KY: { code: '+1345', name: 'Cayman Islands' },
  CF: { code: '+236', name: 'Central African Republic' },
  TD: { code: '+235', name: 'Chad' },
  CL: { code: '+56', name: 'Chile' },
  CN: { code: '+86', name: 'China' },
  CO: { code: '+57', name: 'Colombia' },
  KM: { code: '+269', name: 'Comoros' },
  CG: { code: '+242', name: 'Congo' },
  CD: { code: '+243', name: 'Congo, Democratic Republic' },
  CK: { code: '+682', name: 'Cook Islands' },
  CR: { code: '+506', name: 'Costa Rica' },
  CI: { code: '+225', name: "Cote d'Ivoire" },
  HR: { code: '+385', name: 'Croatia' },
  CU: { code: '+53', name: 'Cuba' },
  CY: { code: '+357', name: 'Cyprus' },
  CZ: { code: '+420', name: 'Czech Republic' },
  DK: { code: '+45', name: 'Denmark' },
  DJ: { code: '+253', name: 'Djibouti' },
  DM: { code: '+1767', name: 'Dominica' },
  DO: { code: '+1', name: 'Dominican Republic' },
  EC: { code: '+593', name: 'Ecuador' },
  EG: { code: '+20', name: 'Egypt' },
  SV: { code: '+503', name: 'El Salvador' },
  GQ: { code: '+240', name: 'Equatorial Guinea' },
  ER: { code: '+291', name: 'Eritrea' },
  EE: { code: '+372', name: 'Estonia' },
  ET: { code: '+251', name: 'Ethiopia' },
  FK: { code: '+500', name: 'Falkland Islands' },
  FO: { code: '+298', name: 'Faroe Islands' },
  FJ: { code: '+679', name: 'Fiji' },
  FI: { code: '+358', name: 'Finland' },
  FR: { code: '+33', name: 'France' },
  GF: { code: '+594', name: 'French Guiana' },
  PF: { code: '+689', name: 'French Polynesia' },
  GA: { code: '+241', name: 'Gabon' },
  GM: { code: '+220', name: 'Gambia' },
  GE: { code: '+995', name: 'Georgia' },
  DE: { code: '+49', name: 'Germany' },
  GH: { code: '+233', name: 'Ghana' },
  GI: { code: '+350', name: 'Gibraltar' },
  GR: { code: '+30', name: 'Greece' },
  GL: { code: '+299', name: 'Greenland' },
  GD: { code: '+1473', name: 'Grenada' },
  GP: { code: '+590', name: 'Guadeloupe' },
  GU: { code: '+1671', name: 'Guam' },
  GT: { code: '+502', name: 'Guatemala' },
  GN: { code: '+224', name: 'Guinea' },
  GW: { code: '+245', name: 'Guinea-Bissau' },
  GY: { code: '+592', name: 'Guyana' },
  HT: { code: '+509', name: 'Haiti' },
  HN: { code: '+504', name: 'Honduras' },
  HK: { code: '+852', name: 'Hong Kong' },
  HU: { code: '+36', name: 'Hungary' },
  IS: { code: '+354', name: 'Iceland' },
  IN: { code: '+91', name: 'India' },
  ID: { code: '+62', name: 'Indonesia' },
  IR: { code: '+98', name: 'Iran' },
  IQ: { code: '+964', name: 'Iraq' },
  IE: { code: '+353', name: 'Ireland' },
  IL: { code: '+972', name: 'Israel' },
  IT: { code: '+39', name: 'Italy' },
  JM: { code: '+1876', name: 'Jamaica' },
  JP: { code: '+81', name: 'Japan' },
  JO: { code: '+962', name: 'Jordan' },
  KZ: { code: '+7', name: 'Kazakhstan' },
  KE: { code: '+254', name: 'Kenya' },
  KI: { code: '+686', name: 'Kiribati' },
  KW: { code: '+965', name: 'Kuwait' },
  KG: { code: '+996', name: 'Kyrgyzstan' },
  LA: { code: '+856', name: 'Laos' },
  LV: { code: '+371', name: 'Latvia' },
  LB: { code: '+961', name: 'Lebanon' },
  LS: { code: '+266', name: 'Lesotho' },
  LR: { code: '+231', name: 'Liberia' },
  LY: { code: '+218', name: 'Libya' },
  LI: { code: '+423', name: 'Liechtenstein' },
  LT: { code: '+370', name: 'Lithuania' },
  LU: { code: '+352', name: 'Luxembourg' },
  MO: { code: '+853', name: 'Macau' },
  MK: { code: '+389', name: 'Macedonia' },
  MG: { code: '+261', name: 'Madagascar' },
  MW: { code: '+265', name: 'Malawi' },
  MY: { code: '+60', name: 'Malaysia' },
  MV: { code: '+960', name: 'Maldives' },
  ML: { code: '+223', name: 'Mali' },
  MT: { code: '+356', name: 'Malta' },
  MH: { code: '+692', name: 'Marshall Islands' },
  MQ: { code: '+596', name: 'Martinique' },
  MR: { code: '+222', name: 'Mauritania' },
  MU: { code: '+230', name: 'Mauritius' },
  YT: { code: '+262', name: 'Mayotte' },
  MX: { code: '+52', name: 'Mexico' },
  FM: { code: '+691', name: 'Micronesia' },
  MD: { code: '+373', name: 'Moldova' },
  MC: { code: '+377', name: 'Monaco' },
  MN: { code: '+976', name: 'Mongolia' },
  ME: { code: '+382', name: 'Montenegro' },
  MS: { code: '+1664', name: 'Montserrat' },
  MA: { code: '+212', name: 'Morocco' },
  MZ: { code: '+258', name: 'Mozambique' },
  MM: { code: '+95', name: 'Myanmar' },
  NA: { code: '+264', name: 'Namibia' },
  NR: { code: '+674', name: 'Nauru' },
  NP: { code: '+977', name: 'Nepal' },
  NL: { code: '+31', name: 'Netherlands' },
  NC: { code: '+687', name: 'New Caledonia' },
  NZ: { code: '+64', name: 'New Zealand' },
  NI: { code: '+505', name: 'Nicaragua' },
  NE: { code: '+227', name: 'Niger' },
  NG: { code: '+234', name: 'Nigeria' },
  NU: { code: '+683', name: 'Niue' },
  NF: { code: '+672', name: 'Norfolk Island' },
  KP: { code: '+850', name: 'North Korea' },
  MP: { code: '+1670', name: 'Northern Mariana Islands' },
  NO: { code: '+47', name: 'Norway' },
  OM: { code: '+968', name: 'Oman' },
  PK: { code: '+92', name: 'Pakistan' },
  PW: { code: '+680', name: 'Palau' },
  PS: { code: '+970', name: 'Palestine' },
  PA: { code: '+507', name: 'Panama' },
  PG: { code: '+675', name: 'Papua New Guinea' },
  PY: { code: '+595', name: 'Paraguay' },
  PE: { code: '+51', name: 'Peru' },
  PH: { code: '+63', name: 'Philippines' },
  PL: { code: '+48', name: 'Poland' },
  PT: { code: '+351', name: 'Portugal' },
  PR: { code: '+1', name: 'Puerto Rico' },
  QA: { code: '+974', name: 'Qatar' },
  RE: { code: '+262', name: 'Reunion' },
  RO: { code: '+40', name: 'Romania' },
  RU: { code: '+7', name: 'Russia' },
  RW: { code: '+250', name: 'Rwanda' },
  KN: { code: '+1869', name: 'Saint Kitts and Nevis' },
  LC: { code: '+1758', name: 'Saint Lucia' },
  VC: { code: '+1784', name: 'Saint Vincent and the Grenadines' },
  WS: { code: '+685', name: 'Samoa' },
  SM: { code: '+378', name: 'San Marino' },
  ST: { code: '+239', name: 'Sao Tome and Principe' },
  SA: { code: '+966', name: 'Saudi Arabia' },
  SN: { code: '+221', name: 'Senegal' },
  RS: { code: '+381', name: 'Serbia' },
  SC: { code: '+248', name: 'Seychelles' },
  SL: { code: '+232', name: 'Sierra Leone' },
  SG: { code: '+65', name: 'Singapore' },
  SK: { code: '+421', name: 'Slovakia' },
  SI: { code: '+386', name: 'Slovenia' },
  SB: { code: '+677', name: 'Solomon Islands' },
  SO: { code: '+252', name: 'Somalia' },
  ZA: { code: '+27', name: 'South Africa' },
  KR: { code: '+82', name: 'South Korea' },
  SS: { code: '+211', name: 'South Sudan' },
  ES: { code: '+34', name: 'Spain' },
  LK: { code: '+94', name: 'Sri Lanka' },
  SD: { code: '+249', name: 'Sudan' },
  SR: { code: '+597', name: 'Suriname' },
  SZ: { code: '+268', name: 'Swaziland' },
  SE: { code: '+46', name: 'Sweden' },
  CH: { code: '+41', name: 'Switzerland' },
  SY: { code: '+963', name: 'Syria' },
  TW: { code: '+886', name: 'Taiwan' },
  TJ: { code: '+992', name: 'Tajikistan' },
  TZ: { code: '+255', name: 'Tanzania' },
  TH: { code: '+66', name: 'Thailand' },
  TL: { code: '+670', name: 'Timor-Leste' },
  TG: { code: '+228', name: 'Togo' },
  TK: { code: '+690', name: 'Tokelau' },
  TO: { code: '+676', name: 'Tonga' },
  TT: { code: '+1868', name: 'Trinidad and Tobago' },
  TN: { code: '+216', name: 'Tunisia' },
  TR: { code: '+90', name: 'Turkey' },
  TM: { code: '+993', name: 'Turkmenistan' },
  TC: { code: '+1649', name: 'Turks and Caicos Islands' },
  TV: { code: '+688', name: 'Tuvalu' },
  UG: { code: '+256', name: 'Uganda' },
  UA: { code: '+380', name: 'Ukraine' },
  AE: { code: '+971', name: 'United Arab Emirates' },
  GB: { code: '+44', name: 'United Kingdom' },
  US: { code: '+1', name: 'United States' },
  UY: { code: '+598', name: 'Uruguay' },
  UZ: { code: '+998', name: 'Uzbekistan' },
  VU: { code: '+678', name: 'Vanuatu' },
  VA: { code: '+39', name: 'Vatican City' },
  VE: { code: '+58', name: 'Venezuela' },
  VN: { code: '+84', name: 'Vietnam' },
  VG: { code: '+1284', name: 'Virgin Islands, British' },
  VI: { code: '+1340', name: 'Virgin Islands, U.S.' },
  WF: { code: '+681', name: 'Wallis and Futuna' },
  YE: { code: '+967', name: 'Yemen' },
  ZM: { code: '+260', name: 'Zambia' },
  ZW: { code: '+263', name: 'Zimbabwe' },
};

// Utility functions for phone number parsing
const parsePhoneNumber = fullPhoneNumber => {
  if (!fullPhoneNumber || !fullPhoneNumber.startsWith('+')) {
    return { countryCode: '+91', phoneNumber: fullPhoneNumber || '' };
  }

  // Sort country codes by length (longest first) for proper matching
  const sortedCodes = Object.values(countryCodeMap)
    .map(country => country.code)
    .sort((a, b) => b.length - a.length);

  for (const code of sortedCodes) {
    if (fullPhoneNumber.startsWith(code)) {
      return {
        countryCode: code,
        phoneNumber: fullPhoneNumber.substring(code.length),
      };
    }
  }

  // Fallback - assume first few digits are country code
  return { countryCode: '+91', phoneNumber: fullPhoneNumber.substring(1) };
};

const combinePhoneNumber = (countryCode, phoneNumber) => {
  if (!countryCode || !phoneNumber) return '';
  return `${countryCode}${phoneNumber}`;
};

// Get all countries with dial codes sorted alphabetically
const getAllCountriesWithDialCodes = () => {
  return Object.entries(countryCodeMap)
    .map(([countryCode, data]) => ({
      countryCode,
      dialCode: data.code,
      name: data.name,
      displayText: `${data.code} (${data.name})`,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
};

// Legacy function for backward compatibility (now uses the comprehensive list)
const getCountryCodesWithFlags = () => {
  return getAllCountriesWithDialCodes();
};

const Settings = () => {
  const [openEdit, setOpenEdit] = useState(false);
  const [isSendingResetLink, setIsSendingResetLink] = useState(false);
  const [countryCodeDropdownOpen, setCountryCodeDropdownOpen] = useState(false);
  const [countryCodeSearch, setCountryCodeSearch] = useState('');
  const fileInputRef = useRef(null);
  const countryCodeDropdownRef = useRef(null);
  const countryCodeSearchRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [adminDetails, setAdminDetails] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone_no: '',
    phone_country_code: '+91',
    phone_number_only: '',
    country: null,
    country_id: null,
    city: null,
    city_id: null,
    language: [],
    language_ids: [],
    user_type: '',
    profile_image: '/placeholder.svg',
  });
  const [originalDetails, setOriginalDetails] = useState({});
  const [errors, setErrors] = useState({});
  const [refresh, setRefresh] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const { refreshProfile, updateProfile } = useProfile();

  // RBAC roles state and one-time fetch guard
  const [rbacMe, setRbacMe] = useState(null);
  const rbacFetchedRef = useRef(false);

  const formatText = text => {
    if (!text) return '';
    const withSpaces = text.replace(/_/g, ' ');
    return withSpaces
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  // Guards to avoid duplicate calls (React 18 Strict Mode) and dedupe in-flight requests
  const didInitRef = useRef(false);
  const staticListsInFlightRef = useRef(false);
  const profileInFlightRef = useRef(false);
  const lastProfileKeyRef = useRef('');

  // Fetch languages from API (deduped)
  const fetchLanguages = async () => {
    if (languages.length > 0) return;
    try {
      const response = await axiosInstance.get('/auth/languages');
      setLanguages(response.data);
    } catch (error) {
      console.error('Error fetching languages:', error);
      // toast.error('Failed to load languages');
    }
  };

  // Fetch countries from API (deduped)
  const fetchCountries = async () => {
    if (countries.length > 0) return;
    try {
      const response = await axiosInstance.get('/auth/countries');
      setCountries(response.data);
    } catch (error) {
      console.error('Error fetching countries:', error);
      // toast.error('Failed to load countries');
    }
  };

  // Fetch cities based on country
  const fetchCities = async countryId => {
    if (!countryId) {
      setCities([]);
      return;
    }

    try {
      const response = await axiosInstance.get(`/auth/countries/${countryId}/cities`);
      setCities(response.data);
    } catch (error) {
      console.error('Error fetching cities:', error);
      toast.error('Failed to load cities');
      setCities([]);
    }
  };

  // Consolidated loader for static lists to avoid duplicate parallel calls
  const loadStaticListsOnce = async () => {
    if (staticListsInFlightRef.current) return;
    staticListsInFlightRef.current = true;
    try {
      await Promise.all([fetchLanguages(), fetchCountries()]);
    } finally {
      staticListsInFlightRef.current = false;
    }
  };

  // Fetch admin profile data (deduped by params)
  const fetchAdminProfile = async () => {
    // Use languages/countries presence to build a key that remains stable
    const key = JSON.stringify({
      hasLang: languages.length > 0,
      hasCountries: countries.length > 0,
    });
    if (profileInFlightRef.current && lastProfileKeyRef.current === key) return;

    profileInFlightRef.current = true;
    lastProfileKeyRef.current = key;

    setLoading(true);
    try {
      const { data } = await axiosInstance.get('/admin/profile');

      // Find country and language objects from their respective arrays
      const countryObj = countries.find(c => c.id === data.country?.id || c.id === data.country_id);

      // Handle languages array
      let languageObjects = [];
      let languageIds = [];

      if (Array.isArray(data.languages) && data.languages.length > 0) {
        languageIds = data.languages.map(lang => (typeof lang === 'object' ? lang.id : lang));
        languageObjects = languages.filter(lang =>
          data.languages.some(
            userLang =>
              (typeof userLang === 'object' && userLang.id === lang.id) || userLang === lang.id
          )
        );
      }

      // Parse phone number
      const phoneData = parsePhoneNumber(data.phone_no);

      // Set admin details from the response
      setAdminDetails({
        first_name: data.first_name || '',
        last_name: data.last_name || '',
        email: data.email || '',
        phone_no: data.phone_no || '',
        phone_country_code: phoneData.countryCode,
        phone_number_only: phoneData.phoneNumber,
        profile_image: data.profile_image || '/placeholder.svg',
        user_type: data.user_type || '',
        country: countryObj || null,
        country_id: data.country_id || (countryObj ? countryObj.id : null),
        city: data.city || null,
        city_id: data.city_id || (data.city ? data.city.id : null),
        language: languageObjects,
        language_ids: languageIds,
      });

      // If country is selected, fetch cities
      if (data.country_id || (countryObj && countryObj.id)) {
        fetchCities(data.country_id || countryObj.id);
      }

      // Store original details for cancel functionality
      setOriginalDetails({
        first_name: data.first_name || '',
        last_name: data.last_name || '',
        email: data.email || '',
        phone_no: data.phone_no || '',
        phone_country_code: phoneData.countryCode,
        phone_number_only: phoneData.phoneNumber,
        profile_image: data.profile_image || '/placeholder.svg',
        user_type: data.user_type || '',
        country: countryObj || null,
        country_id: data.country_id || (countryObj ? countryObj.id : null),
        city: data.city || null,
        city_id: data.city_id || (data.city ? data.city.id : null),
        language: languageObjects,
        language_ids: languageIds,
      });

      // Reset refresh state after successful fetch
      setRefresh(false);
    } catch (error) {
      console.error('Error fetching admin profile:', error);
      toast.error(error.response?.data?.detail || 'Failed to fetch profile');
      setRefresh(false); // Reset refresh state even on error
    } finally {
      setLoading(false);
      profileInFlightRef.current = false;
    }
  };

  // One-time RBAC profile fetch with sessionStorage caching
  useEffect(() => {
    if (rbacFetchedRef.current) return;
    rbacFetchedRef.current = true;

    let cachedData = null;
    try {
      const cached = sessionStorage.getItem('rbac_admin_me');
      if (cached) {
        cachedData = JSON.parse(cached);
        setRbacMe(cachedData);
      }
    } catch (_) {}

    (async () => {
      try {
        const { data } = await axiosInstance.get('/admin/rbac/admin/me');
        setRbacMe(data);
        try {
          sessionStorage.setItem('rbac_admin_me', JSON.stringify(data));
        } catch (_) {}
      } catch (_) {
        if (!cachedData) setRbacMe({ roles: [] });
      }
    })();
  }, []);

  useEffect(() => {
    // Load static lists exactly once on mount (guards Strict Mode double-invoke)
    if (didInitRef.current) return;
    didInitRef.current = true;
    loadStaticListsOnce();
  }, []);

  useEffect(() => {
    // Only fetch profile after languages and countries are loaded
    if (languages.length > 0 && countries.length > 0) {
      fetchAdminProfile();
    }
  }, [languages, countries, refresh]);

  // Handle clicking outside the country code dropdown
  useEffect(() => {
    const handleClickOutside = event => {
      if (
        countryCodeDropdownRef.current &&
        !countryCodeDropdownRef.current.contains(event.target)
      ) {
        setCountryCodeDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleRefresh = () => {
    setRefresh(true); // Set refresh to true to trigger useEffect
  };

  const handleCountryCodeSelect = dialCode => {
    handleInputChange('phone_country_code', dialCode);
    setCountryCodeDropdownOpen(false);
    setCountryCodeSearch(''); // Clear search when selecting
  };

  const getFilteredCountries = () => {
    if (!countryCodeSearch.trim()) {
      return getAllCountriesWithDialCodes();
    }

    const searchTerm = countryCodeSearch.toLowerCase().trim();
    return getAllCountriesWithDialCodes().filter(
      country =>
        country.name.toLowerCase().includes(searchTerm) ||
        country.dialCode.includes(searchTerm) ||
        country.countryCode.toLowerCase().includes(searchTerm)
    );
  };

  const handleCountryCodeDropdownToggle = () => {
    const newState = !countryCodeDropdownOpen;
    setCountryCodeDropdownOpen(newState);

    if (newState) {
      // Focus search input when opening dropdown
      setTimeout(() => {
        if (countryCodeSearchRef.current) {
          countryCodeSearchRef.current.focus();
        }
      }, 100);
    } else {
      // Clear search when closing dropdown
      setCountryCodeSearch('');
    }
  };

  const handleSearchKeyDown = e => {
    if (e.key === 'Escape') {
      setCountryCodeDropdownOpen(false);
      setCountryCodeSearch('');
    } else if (e.key === 'Enter') {
      e.preventDefault();
      const filteredCountries = getFilteredCountries();
      if (filteredCountries.length > 0) {
        handleCountryCodeSelect(filteredCountries[0].dialCode);
      }
    }
  };

  const handleAddIconClick = () => {
    fileInputRef.current.click();
  };

  const uploadProfileImage = async file => {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await axiosInstance.post('/auth/users/profile_upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 200) {
        return response.data.profile_image_url;
      }
    } catch (error) {
      console.error('Error uploading profile image:', error);
      return null;
    }
  };

  const handleImageChange = async event => {
    const file = event.target.files[0];
    if (file) {
      try {
        // Show preview immediately using local file
        const localPreviewUrl = URL.createObjectURL(file);
        setAdminDetails(prev => ({
          ...prev,
          profile_image: localPreviewUrl,
        }));

        // Upload to server
        const imageUrl = await uploadProfileImage(file);

        if (imageUrl) {
          // Add a timestamp to prevent caching
          const cachedImageUrl = `${imageUrl}?t=${new Date().getTime()}`;

          // Update profile image in state with server URL
          setAdminDetails(prev => ({
            ...prev,
            profile_image: cachedImageUrl,
          }));

          // Store in originalDetails to prevent reversion on cancel
          setOriginalDetails(prev => ({
            ...prev,
            profile_image: cachedImageUrl,
          }));

          // Optimistically update ProfileContext so navbar updates immediately
          updateProfile({ profile_image: cachedImageUrl });

          toast.success('Profile image updated successfully');

          // Ensure navbar and any other consumers refresh from server
          try {
            await refreshProfile();
          } catch {}
        }
      } catch (error) {
        console.error('Error uploading image:', error);
        // toast.error('Failed to upload image');
        // Revert to original image on error
        handleRefresh();
      } finally {
        // Clean up object URL
        URL.revokeObjectURL(adminDetails.profile_image);
      }
    }
  };

  const handleEdit = () => {
    setOriginalDetails({ ...adminDetails });
    setOpenEdit(true);
  };

  const updateAdminProfile = async details => {
    try {
      const response = await axiosInstance.patch('/admin/profile_update', details);
      if (response.status === 200) {
        toast.success('Profile updated successfully');
        return { success: true };
      }
    } catch (error) {
      console.error('Error updating admin profile:', error);
      const errorMessage = error.response?.data?.detail || 'Failed to update profile';
      toast.error(errorMessage);
      return { success: false, error: errorMessage };
    }
  };

  const handleSave = async () => {
    const newErrors = {};
    if (!adminDetails.first_name.trim() || !/^[A-Za-z\s]*$/.test(adminDetails.first_name)) {
      newErrors.first_name = 'First name is required and should only contain letters and spaces';
    }
    if (!adminDetails.last_name.trim() || !/^[A-Za-z\s]*$/.test(adminDetails.last_name)) {
      newErrors.last_name = 'Last name is required and should only contain letters and spaces';
    }
    if (
      !adminDetails.phone_number_only.trim() ||
      !/^\d{7,15}$/.test(adminDetails.phone_number_only)
    ) {
      newErrors.phone_no = 'Phone number must be 7-15 digits';
    }

    if (Object.keys(newErrors).length === 0) {
      const detailsToUpdate = {
        first_name: adminDetails.first_name,
        last_name: adminDetails.last_name,
        phone_no: combinePhoneNumber(
          adminDetails.phone_country_code,
          adminDetails.phone_number_only
        ),
        profile_image: adminDetails.profile_image,
        country_id: adminDetails.country_id,
        city_id: adminDetails.city_id,
        language_ids: adminDetails.language_ids,
      };

      const result = await updateAdminProfile(detailsToUpdate);
      if (result.success) {
        setOpenEdit(false);
        setErrors({});
        // Optimistically update profile context with possible name change
        updateProfile({
          first_name: adminDetails.first_name,
          last_name: adminDetails.last_name,
          profile_image: adminDetails.profile_image,
          user_type: adminDetails.user_type,
        });
        handleRefresh(); // Refresh to get updated profile data
        try {
          await refreshProfile();
        } catch {}
      } else {
        setErrors({ general: result.error });
      }
    } else {
      setErrors(newErrors);
    }
  };

  const handleCancel = () => {
    setOpenEdit(false);
    setErrors({});
    setAdminDetails(originalDetails);
  };

  const handlePasswordReset = async () => {
    const email = adminDetails?.email;

    if (!email) {
      toast.error('Email address not found for your account');
      return;
    }

    setIsSendingResetLink(true);
    try {
      const response = await axiosInstance.post('/auth/forgot-password', {
        email: email,
      });

      if (response.status === 200) {
        toast.success(`Password reset link sent to ${email}`);
      }
    } catch (error) {
      console.error('Password reset error:', error);
      let errorMessage = 'Failed to send password reset email';

      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          errorMessage = error.response.data.detail[0]?.msg || errorMessage;
        } else {
          errorMessage = error.response.data.detail;
        }
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }

      toast.error(errorMessage);
    } finally {
      setIsSendingResetLink(false);
    }
  };

  const handleInputChange = (field, value) => {
    let errorMessage = '';

    switch (field) {
      case 'first_name':
      case 'last_name':
        if (!/^[A-Za-z\s]*$/.test(value)) {
          errorMessage = 'Name should only contain letters and spaces';
        }
        break;
      case 'phone_number_only':
        if (!/^\d*$/.test(value)) {
          errorMessage = 'Phone number should only contain digits';
        } else if (value.length > 0 && (value.length < 7 || value.length > 15)) {
          errorMessage = 'Phone number must be 7-15 digits';
        }
        break;
      case 'phone_country_code':
        setAdminDetails(prev => ({
          ...prev,
          phone_country_code: value,
        }));
        return; // Early return to avoid the setAdminDetails below
      case 'country_id':
        // Find the country object
        const selectedCountry = countries.find(c => c.id === parseInt(value));
        setAdminDetails(prev => ({
          ...prev,
          country: selectedCountry,
          country_id: parseInt(value),
          // Reset city when country changes
          city: null,
          city_id: null,
        }));
        // Fetch cities for the selected country
        fetchCities(parseInt(value));
        return; // Early return to avoid the setAdminDetails below
      case 'city_id':
        // Find the city object
        const selectedCity = cities.find(c => c.id === parseInt(value));
        setAdminDetails(prev => ({
          ...prev,
          city: selectedCity,
          city_id: parseInt(value),
        }));
        return; // Early return
      case 'language_ids':
        // Handle language selection
        const languageId = parseInt(value[0]);
        const selectedLanguage = languages.find(l => l.id === languageId);

        setAdminDetails(prev => ({
          ...prev,
          language: selectedLanguage ? [selectedLanguage] : [],
          language_ids: selectedLanguage ? [languageId] : [],
        }));
        return; // Early return
      default:
        break;
    }

    setAdminDetails(prev => ({
      ...prev,
      [field]: value,
    }));

    setErrors(prev => ({
      ...prev,
      [field]: errorMessage,
    }));
  };

  // Build display role string from RBAC roles or fallback to user_type
  const roles = Array.isArray(rbacMe?.roles) ? rbacMe.roles : [];
  const displayRole = roles.length
    ? roles.map(role => formatText(role)).join(', ')
    : adminDetails.user_type || '';

  const getInitials = () => {
    const firstInitial = adminDetails.first_name?.charAt(0)?.toUpperCase() || '';
    const lastInitial = adminDetails.last_name?.charAt(0)?.toUpperCase() || '';
    const initials = firstInitial + lastInitial;
    return initials || '';
  };

  return (
    <>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
          <ProfileSkeleton />
        </Box>
      ) : (
        <Layout title="Klass Online | Settings">
          <Box className="relative h-screen w-full overflow-hidden">
            <Box className="sticky top-0 left-0 right-0 z-[1000] bg-white pr-[10px]">
              <AdminNavbar />
            </Box>
            <Box className="h-[calc(100vh-64px)] overflow-auto relative bg-[#F9F9F9] rounded-lg mr-[10px]">
              <Box className="flex flex-col p-[1rem] gap-4">
                <Box className="flex flex-col ">
                  <Typography className="setting-title">Settings</Typography>
                  <div className="settings-form">
                    <div className="image-row" sx={{ cursor: 'default' }}>
                      <div className="avatar-container">
                        <Avatar
                          className="avatar-image"
                          src={
                            adminDetails.profile_image &&
                            adminDetails.profile_image.startsWith('http')
                              ? adminDetails.profile_image
                              : undefined
                          }
                          sx={{
                            width: '150px',
                            height: '150px',
                            bgcolor:
                              adminDetails.profile_image &&
                              adminDetails.profile_image.startsWith('http')
                                ? 'transparent'
                                : '#949DA6',
                            color: '#FFFFFF',
                            fontSize: '48px',
                            fontWeight: 600,
                          }}
                          onError={e => {
                            e.target.style.display = 'none';
                          }}
                        >
                          {(!adminDetails.profile_image ||
                            !adminDetails.profile_image.startsWith('http')) &&
                            (adminDetails.first_name || adminDetails.last_name) &&
                            getInitials()}
                        </Avatar>
                        <div className="avatar-edit-icon" onClick={handleAddIconClick}>
                          <span>+</span>
                        </div>
                        <input
                          type="file"
                          ref={fileInputRef}
                          onChange={handleImageChange}
                          style={{ display: 'none' }}
                          accept="image/*"
                        />
                      </div>
                      <div>
                        {openEdit ? (
                          <>
                            <button onClick={handleSave} className="edit-save-button mr-2">
                              Save
                            </button>
                            <button onClick={handleCancel} className="edit-save-button">
                              Cancel
                            </button>
                          </>
                        ) : (
                          <button onClick={handleEdit} className="edit-save-button">
                            Edit
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="form-grid bg-white ">
                      <div className="form-group">
                        <label className="form-label-admin">First Name</label>
                        <input
                          type="text"
                          value={adminDetails.first_name}
                          onChange={e => handleInputChange('first_name', e.target.value)}
                          disabled={!openEdit}
                          className={`form-input-admin ${!openEdit ? 'disabled' : ''}`}
                          pattern="[A-Za-z ]+"
                        />
                        {errors.first_name && (
                          <span className="error-text">{errors.first_name}</span>
                        )}
                      </div>
                      <div className="form-group">
                        <label className="form-label-admin">Last Name</label>
                        <input
                          type="text"
                          value={adminDetails.last_name}
                          onChange={e => handleInputChange('last_name', e.target.value)}
                          disabled={!openEdit}
                          className={`form-input-admin ${!openEdit ? 'disabled' : ''}`}
                          pattern="[A-Za-z ]+"
                        />
                        {errors.last_name && <span className="error-text">{errors.last_name}</span>}
                      </div>
                      <div className="form-group">
                        <label className="form-label-admin">Email</label>
                        <input
                          type="email"
                          value={adminDetails.email}
                          disabled={true} /* Email always disabled */
                          className="form-input-admin disabled"
                        />
                        {errors.email && <span className="error-text">{errors.email}</span>}
                      </div>
                      <div className="form-group">
                        <label className="form-label-admin">Phone Number</label>
                        {openEdit ? (
                          <div className="phone-input-container">
                            <div
                              className={`country-code-dropdown-container ${countryCodeDropdownOpen ? 'open' : ''}`}
                              ref={countryCodeDropdownRef}
                            >
                              <div
                                className="country-code-display-button"
                                onClick={handleCountryCodeDropdownToggle}
                              >
                                <span>{adminDetails.phone_country_code}</span>
                                <span className="dropdown-arrow">▼</span>
                              </div>
                              {countryCodeDropdownOpen && (
                                <div className="country-code-dropdown">
                                  <div className="country-code-search-container">
                                    <input
                                      ref={countryCodeSearchRef}
                                      type="text"
                                      placeholder="Search countries..."
                                      value={countryCodeSearch}
                                      onChange={e => setCountryCodeSearch(e.target.value)}
                                      className="country-code-search-input"
                                      onKeyDown={handleSearchKeyDown}
                                    />
                                  </div>
                                  <div className="country-code-dropdown-content">
                                    {getFilteredCountries().length > 0 ? (
                                      getFilteredCountries().map((country, index) => (
                                        <div
                                          key={`${country.dialCode}-${country.countryCode}-${index}`}
                                          className={`country-code-option ${adminDetails.phone_country_code === country.dialCode ? 'selected' : ''}`}
                                          onClick={() => handleCountryCodeSelect(country.dialCode)}
                                        >
                                          {country.displayText}
                                        </div>
                                      ))
                                    ) : (
                                      <div className="country-code-no-results">
                                        No countries found
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                            <input
                              type="tel"
                              value={adminDetails.phone_number_only}
                              onChange={e => handleInputChange('phone_number_only', e.target.value)}
                              className="phone-number-input"
                              placeholder="Enter phone number"
                              maxLength={15}
                            />
                          </div>
                        ) : (
                          <div className="phone-display">
                            <span className="country-code-display">
                              {adminDetails.phone_country_code}
                            </span>
                            <span className="phone-number-display">
                              {adminDetails.phone_number_only}
                            </span>
                          </div>
                        )}
                        {errors.phone_no && <span className="error-text">{errors.phone_no}</span>}
                      </div>

                      <div className="form-group">
                        <label className="form-label-admin">Country</label>
                        {openEdit ? (
                          <select
                            value={adminDetails.country_id || ''}
                            onChange={e => {
                              handleInputChange('country_id', e.target.value);
                            }}
                            className="form-input-admin dropdown-select"
                          >
                            <option value="">Select a country</option>
                            {countries.map(country => (
                              <option key={country.id} value={country.id}>
                                {country.name}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <div className="country-display">
                            {adminDetails.country && (
                              <ReactCountryFlag
                                countryCode={adminDetails.country?.code || ''}
                                svg
                                style={{ marginRight: '8px' }}
                              />
                            )}
                            <span>{adminDetails.country?.name || 'Not specified'}</span>
                          </div>
                        )}
                      </div>

                      <div className="form-group">
                        <label className="form-label-admin">City</label>
                        {openEdit ? (
                          <select
                            value={adminDetails.city_id || ''}
                            onChange={e => {
                              handleInputChange('city_id', e.target.value);
                            }}
                            className="form-input-admin dropdown-select"
                            disabled={!adminDetails.country_id}
                          >
                            <option value="">Select a city</option>
                            {cities.map(city => (
                              <option key={city.id} value={city.id}>
                                {city.name}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            type="text"
                            value={adminDetails.city?.name || 'Not specified'}
                            disabled
                            className="form-input-admin disabled"
                          />
                        )}
                      </div>

                      <div className="form-group">
                        <label className="form-label-admin">Language</label>
                        {openEdit ? (
                          <select
                            value={adminDetails.language_ids[0] || ''}
                            onChange={e => {
                              handleInputChange('language_ids', [e.target.value]);
                            }}
                            className="form-input-admin dropdown-select"
                          >
                            <option value="">Select a language</option>
                            {languages.map(language => (
                              <option key={language.id} value={language.id}>
                                {language.name}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            type="text"
                            value={
                              adminDetails.language && adminDetails.language.length > 0
                                ? adminDetails.language[0]?.name || 'Not specified'
                                : 'Not specified'
                            }
                            disabled
                            className="form-input-admin disabled"
                          />
                        )}
                      </div>

                      <div className="form-group">
                        <label className="form-label-admin">Role</label>
                        <input
                          type="text"
                          value={displayRole ? formatText(displayRole) : ''}
                          disabled
                          className="form-input-admin disabled"
                        />
                      </div>
                    </div>
                    <button
                      onClick={handlePasswordReset}
                      disabled={isSendingResetLink}
                      className="reset-password-button-settings"
                    >
                      {isSendingResetLink ? 'Sending Reset Link...' : 'Reset Password'}
                    </button>
                    {errors.general && (
                      <div className="error-text text-center mt-4">{errors.general}</div>
                    )}
                  </div>
                </Box>
              </Box>
            </Box>
          </Box>
        </Layout>
      )}
    </>
  );
};

export default Settings;
